<script>
  import { onMount, onDestroy } from 'svelte';

  let { endDate, children } = $props();
  let timer = null;
  let remaining = $state();
  let difference = $state();
  let inactive = $state(true);

  function countdownTimer() {
    let target;

    try {
      target = +new Date(endDate);
    } catch {
      // `endDate` is a prop, so it can be backed by a $derived whose owning effect has already
      // been torn down (this component is often rendered inside an {#if} driven by the same
      // value). Svelte then hands back an internal sentinel Symbol, and coercing it throws
      // "Cannot convert a Symbol value to a number" — Rollbar #2473 / #2474 / #2470 / #2439.
      // Skip this tick rather than clearing the interval. Instances are reused — pack lists
      // re-render with `bundleName + '-' + index` keys — so a component that survives can be
      // handed a valid endDate again and has to be able to resume; clearing the timer would
      // leave it permanently blank. Nothing escapes the catch, so a derived that stays dead
      // just costs a no-op tick until onDestroy clears the timer.
      remaining = '';
      inactive = true;

      return;
    }

    difference = target - Date.now();
    remaining = '';

    inactive = true;

    if (difference > 0) {
      inactive = false;
      const parts = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24)
          .toString()
          .padStart(2, '0'),
        minutes: Math.floor((difference / 1000 / 60) % 60)
          .toString()
          .padStart(2, '0'),
        seconds: Math.floor((difference / 1000) % 60)
          .toString()
          .padStart(2, '0'),
      };

      remaining = `${parts.minutes}:${parts.seconds}`;

      // more than 1 hour
      if (difference / 1000 >= 60 * 60) {
        remaining = `${parts.hours}:${parts.minutes}:${parts.seconds}`;
      }

      // more than 1 day
      if (difference / 1000 >= 60 * 60 * 24) {
        remaining = `${parts.days}d ${parts.hours}:${parts.minutes}:${parts.seconds}`;
      }
    }
  }

  onMount(() => {
    timer = setInterval(countdownTimer, 1000);
  });

  onDestroy(() => {
    if (timer) {
      clearInterval(timer);
    }
  });

  $effect(() => {
    if (difference === 0) {
      clearInterval(timer);
      timer = null;
    }
  });
</script>

<span class:inactive class="timer">{@render children?.()} {remaining}</span>

<style lang="scss">
  .inactive {
    opacity: 0;
  }
</style>
